const Tooltip = ({ children, toolTip }) => {
  const content = toolTip && (
    <div className="">
      <div className="lexcms-alert-popover-content">
        <div className="lexcms-alert-popover-text">{children}</div>
      </div>
    </div>
  );
  return content;
};
export default Tooltip;
